import {
  StandardNextButton,
  StandardStepSubtitleText,
  StandardStepTitle,
  StepWrapper
} from '../../components';
import { useWizard } from 'react-use-wizard';
import { useGAFormTracking } from '../../../../shared/hooks';
import { useReferralContext } from '../../context';
import { FieldErrors, useForm } from 'react-hook-form';
import { trackStepCompleted } from '../../../../shared/analytics';
import {
  getFormName,
  useTrackStepError,
  useTrackStepStarted
} from '../../utils';
import { PHUrgencyOptions } from '../../enums';
import { yupResolver } from '@hookform/resolvers/yup';
import { phUrgencySchema } from '../../schemas/singleOptionSchema';
import { GenericRadioTileGroup } from '../steps';

const STEP_NAME = 'ph_urgency_step';
const STEP_LABEL = 'When are you hoping to have this done?';

function PHUrgencyStep() {
  const { nextStep, activeStep } = useWizard();
  const formRef = useGAFormTracking(STEP_NAME);
  const { referral, updateReferral } = useReferralContext();
  const { register, handleSubmit, formState } = useForm<{ ph_urgency: string }>(
    {
      defaultValues: { ph_urgency: referral.ph_urgency },
      resolver: yupResolver(phUrgencySchema)
    }
  );

  const errorMessage = formState.errors.ph_urgency?.message;

  useTrackStepStarted(activeStep + 1, STEP_NAME, STEP_LABEL);
  const trackError = useTrackStepError(activeStep + 1, STEP_NAME, STEP_LABEL);

  async function onValidSubmit(values: { ph_urgency: string }) {
    trackStepCompleted({
      step: activeStep + 1,
      step_name: STEP_NAME,
      step_label: STEP_LABEL,
      answer_labels: Object.values(PHUrgencyOptions),
      answer_values: [values.ph_urgency],
      form_name: getFormName()
    });
    updateReferral({
      ...referral,
      ph_urgency: values.ph_urgency
    });
    await nextStep();
  }

  function onInvalid(formErrors: FieldErrors<{ ph_urgency: string }>) {
    trackError('validation', formErrors.ph_urgency?.message, 'ph_urgency');
  }

  return (
    <StepWrapper>
      <form ref={formRef} onSubmit={handleSubmit(onValidSubmit, onInvalid)}>
        <StandardStepTitle>{STEP_LABEL}</StandardStepTitle>
        <StandardStepSubtitleText>
          We'll connect you right away - this just helps us understand your
          timeline.
        </StandardStepSubtitleText>
        <GenericRadioTileGroup
          options={PHUrgencyOptions}
          idSuffix="_ph_urgency_radio_tile"
          registration={register('ph_urgency')}
          errorMessage={errorMessage}
        />
        <StandardNextButton />
      </form>
    </StepWrapper>
  );
}

export { PHUrgencyStep };
